import { AuthHeroPanel } from './AuthHeroPanel';

export function SignInCarousel() {
    return <AuthHeroPanel />;
}
